import { useMediaQuery } from 'react-responsive';

interface DeviceTypes {
  isMobile: boolean;
  isMobileOrTablet: boolean;
  isTablet: boolean;
  isTabletOrDesktop: boolean;
  isDesktop: boolean;
  isLargeDesktop: boolean;
  isRetina: boolean;
}

const RETINA_RESOLUTION_DPI = 192;
const RETINA_RESOLUTION_DPCM = 75.6;
const RETINA_RESOLUTION_DPPX = 2;
const RETINA_PIXEL_RATIO = 2;

export const screenSizes = {
  xs: 375,
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  xl1: 1366,
  xl2: 1440,
  xl3: 1920,
  xl4: 2560,
};

export function useResponsive(): DeviceTypes {
  const isMobile = useMediaQuery({ maxWidth: screenSizes.md - 1 });
  const isMobileOrTablet = useMediaQuery({ maxWidth: screenSizes.lg - 1 });
  const isTablet = useMediaQuery({
    minWidth: screenSizes.md,
    maxWidth: screenSizes.lg - 1,
  });
  const isTabletOrDesktop = useMediaQuery({ minWidth: screenSizes.md });
  const isDesktop = useMediaQuery({ minWidth: screenSizes.lg });
  const isLargeDesktop = useMediaQuery({ minWidth: screenSizes.xl3 });
  const isRetina = useMediaQuery({
    query: `only screen and (min-resolution: ${RETINA_RESOLUTION_DPI}dpi), only screen and (min-resolution: ${RETINA_RESOLUTION_DPPX}dppx),
       only screen and (min-resolution: ${RETINA_RESOLUTION_DPCM}dpcm), 
      only screen and (-webkit-min-device-pixel-ratio: ${RETINA_PIXEL_RATIO}), only screen and (-o-min-device-pixel-ratio: ${RETINA_PIXEL_RATIO}/1),
       only screen and (min--moz-device-pixel-ratio: ${RETINA_PIXEL_RATIO}), only screen and (min-device-pixel-ratio: ${RETINA_PIXEL_RATIO})`,
  });

  return {
    isMobile,
    isMobileOrTablet,
    isTablet,
    isTabletOrDesktop,
    isDesktop,
    isLargeDesktop,
    isRetina,
  };
}
